// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p3-0";
export var animationContainer = "_p3-1";
export var itemPrice = "_p3-a";
export var itemizedContent = "_p3-9";
export var itemizedHeader = "_p3-7";
export var itemizedRow = "_p3-8";
export var itemizedSection = "_p3-6";
export var modalContent = "_p3-2";
export var orderName = "_p3-3";
export var refundOption = "_p3-4";
export var refundOptionsContainer = "_p3-5";
export var shippingLabel = "_p3-b";
export var totalRow = "_p3-c";